import axios from "axios";
import { common } from "../../utils";
import { API_URL } from "../../utils/api-utils";
//Manipulate with ExecutionPlanList
export const Upload = async (param) => {
  let url = `${API_URL.Loader}/api/TextLoader/Upload`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

export const GetTextLoaderData = async (param) => {
  let url = `${API_URL.Loader}/api/TextLoader/GetTextLoaderData`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

export const GetListViewHistory = async (param) => {
  let url = `${API_URL.Loader}/api/TextLoader/GetListViewHistory`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};


// Master
export const GetListTopicType = async (param) => {
  let url = `${API_URL.Loader}/api/Master/GetListTopicType`;
  let { result } = await common.to(axios.post(url, param));

  const listSelect = [];
  if (result && result.data) 
  {
    result.data.map(
      (item) => listSelect.push({ id: item.TOPIC_ID, label: item.LOAD_TOPIC })
    );
  }
  
  return listSelect;
};

export const GetListEncryptMap = async (param) => {
  let url = `${API_URL.Loader}/api/Master/GetListEncryptMap`;
  let { result } = await common.to(axios.post(url, param));

  const listSelect = [];
  if (result && result.data) 
  {
    result.data.map(
      (item) => listSelect.push({ id: item.ENCRYPT_ID, label: item.ENCRYPT_NAME })
    );
  }
  
  return listSelect;
};

export const GetListHost = async (param) => {
  let url = `${API_URL.Loader}/api/Master/GetListHost`;
  let { result } = await common.to(axios.post(url, param));

  const listSelect = [];
  if (result && result.data) 
  {
    result.data.map(
      (item) => listSelect.push({ id: item.HOST_KEY, label: item.HOST_TITLE })
    );
  }
  
  return listSelect;
};

